import { Component, OnInit , Input } from '@angular/core';
import {Globals} from '../../services/globals';

@Component({
  selector: 'app-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.css']
})
export class NoDataComponent implements OnInit {
  
  assetsUrl = '';

  @Input ('imagename') imagename : string; 
  @Input ('altname') altname : string; 
  @Input ('h2') h2 : string; 
  @Input ('p') p : string; 
  
  constructor(public globals: Globals) { 
    this.assetsUrl = this.globals.getAssetsUrl();       
  }

  ngOnInit() {
  }

}
